import { LayerDTO } from "./LayerDTO";

export class LayerGroup
{
    name : string;
    isGeneratedLayerGroupExpanded: boolean;
    layerList: LayerDTO[];
}